import Modal from "@mui/material/Modal";
import "./CreditNoteModal.css";
import CloseIcon from "@mui/icons-material/Close";
import { useState, useEffect } from "react";
import { fetchCreditNoteByNumber } from "../../services/collectionService";
import { Loader } from "../../../../components/loader/Loader";
import { CreditNoteDetails } from "../../collectionUtils";
import { truncateToTwoDecimals } from "../../../../components/dms_common/DmsUtils";


interface CreditNoteModalProps {
  open: boolean;
  onClose: () => void;
  creditNoteNumber: string;
}

const CreditNoteModal = ({ open, onClose, creditNoteNumber }: CreditNoteModalProps) => {
  const [creditNoteDetails, setCreditNoteDetails] = useState<CreditNoteDetails | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!open || !creditNoteNumber) {
        setCreditNoteDetails(null);
        setError(null);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const data = await fetchCreditNoteByNumber(creditNoteNumber);
        setCreditNoteDetails(data);
      } catch (err) {
        setError("Failed to fetch credit note details");
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [open, creditNoteNumber]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="credit-note-modal-container">
        {loading ? (
          <Loader />
        ) : error ? (
          <div style={{ color: "red", padding: "20px", textAlign: "center" }}>
            {error}
          </div>
        ) : creditNoteDetails ? (
          <>
            <div className="creditNoteHeader">
              <p className="creditNoteHeaderTitle">Credit Note {creditNoteDetails.creditNoteNumber}</p>
              <CloseIcon style={{ cursor: "pointer" }} onClick={onClose} />
            </div>

            <div className="credit-note-item">
              <div className="credit-note-detail" style={{ paddingRight: "0" }}>
                <span className="credit-note-label">Issue Date</span>
                <div className="credit-note-value">{creditNoteDetails.issueDate}</div>
              </div>
              <div className="credit-note-detail" style={{ paddingRight: "0" }}>
                <span className="credit-note-label">Return Order No.</span>
                <div className="credit-note-value">{creditNoteDetails.returnId}</div>
              </div>
            </div>

            <div className="credit-note-divider">
              <p>Enter Return Value</p>
              <p></p>
            </div>

            <div className="credit-note-item">
              <div className="credit-note-detail" style={{ paddingRight: "0" }}>
                <span className="credit-note-label">Final Value</span>
                <div className="credit-note-value">₹ {truncateToTwoDecimals(creditNoteDetails.amount)}</div>
              </div>
            </div>

            <div className="credit-note-divider">
              <p>Enter Validity</p>
              <p></p>
            </div>

            <div className="credit-note-item">
              <div className="credit-note-detail" style={{ paddingRight: "0" }}>
                <span className="credit-note-label">Start From</span>
                <div className="credit-note-value">{creditNoteDetails.startDate}</div>
              </div>
              <div className="credit-note-detail" style={{ paddingRight: "0" }}>
                <span className="credit-note-label">Validate Till</span>
                <div className="credit-note-value">{creditNoteDetails.endDate}</div>
              </div>
            </div>
          </>
        ) : (
          <div style={{ padding: "20px", textAlign: "center" }}>
            No credit note details available
          </div>
        )}
      </div>
    </Modal>
  );
};

export default CreditNoteModal;